







































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
@Component({
  components: {}
})
export default class PaySetting extends AbpBase {
  WechatPayConfig = {
    MchKey: null,
    MchId: null,
    AppId: null,
    Host: null,
    CertUlr: null
  }

  ruleWechatPayConfig = {
    MchKey: [{ required: true, message: '请输入应用密钥', trigger: 'blur' }],
    MchId: [{ required: true, message: '请输入商户号', trigger: 'blur' }],
    CertUlr: [{ required: true, message: '请输入API证书', trigger: 'blur' }],
    AppId: [{ required: true, message: '请输入AppId', trigger: 'blur' }],
    Host: [{ required: true, message: '请输入回调域名', trigger: 'blur' }]
  }

  created() {
    this.getConfig('WechatPayConfig')
  }

  /**
   * 获取设置
   */
  getConfig(key) {
    MallConfig.getMallConfig(key).then(res => {
      if (res.data) {
        this[key] = res.data
      }
    })
  }

  /**
   * 微信支付设置
   */
  WechatPaySubmit() {
    let vm = this
    let WechatPayConfig: any = vm.$refs.WechatPayConfig
    WechatPayConfig.validate(valid => {
      if (valid) {
        MallConfig.updateMallConfig(
          'WechatPayConfig',
          '微信支付设置',
          vm.WechatPayConfig
        ).then(res => {
          vm.$Notice.success({
            desc: '提交成功'
          })
          vm.getConfig('WechatPayConfig')
        })
      }
    })
  }
}
